import moment, { Moment } from 'moment';
import { Toggle } from 'ui/toggle';
import { Link } from 'ui/links';
import { SingleDateFooterWrapper, ToggleContainer } from './SingleDatePicker.styles';

type SingleDateFooterProps = {
  /** toggle value  */
  isRelative: boolean;
  /** function to set is relative */
  setIsRelative: (isRelative: boolean) => void;
  /** function to set date */
  setCurrentDate: (date: string | Moment) => void;
};

export const SingleDateFooter = ({
  isRelative,
  setIsRelative,
  setCurrentDate,
}: SingleDateFooterProps) => {
  const toggleRelativeDate = () => {
    const defaultVal = !isRelative ? '' : moment();
    setIsRelative(!isRelative);
    // clear date on toggle
    setCurrentDate(defaultVal);
  };

  return (
    <SingleDateFooterWrapper>
      <ToggleContainer>
        <Toggle
          isActive={isRelative}
          id="isrelativedate-toggle"
          labelId="relative-toggle"
          onClick={toggleRelativeDate}
        />
        <label id="relative-toggle" htmlFor="isrelativedate-toggle">
          Relative date
        </label>
      </ToggleContainer>
      {isRelative && (
        <Link
          hasOpenNewTabIcon
          rel="noopener noreferrer"
          target="_blank"
          href="https://support.iterable.com/hc/en-us/articles/360012688571-Relative-Dates-#example-relative-date-expressions"
        >
          Help
        </Link>
      )}
    </SingleDateFooterWrapper>
  );
};
